import type { CalculatorMeta } from "../../types/calculator";

const meta: CalculatorMeta = {
  route: "/potential-energy-calculator",
  component: () => import("../../routes/PotentialEnergyCalculator.svelte"),
  card: {
    id: "potential-energy-calculator",
    title: "Potential Energy Calculator",
    description:
      "Calculate gravitational potential energy, mass, height, or local gravity using the PE = mgh formula. Includes a planet selector for Earth, Moon, Mars, Jupiter, and more.",
    icon: "landscape",
    iconBgClass: "bg-emerald-50",
    iconTextClass: "text-emerald-600",
    href: "/potential-energy-calculator",
    category: "Physics & Science",
  },
  seo: {
    title:
      "Potential Energy Calculator – PE = mgh Solver for Any Planet",
    description:
      "Free gravitational potential energy calculator using PE = m × g × h. Solve for PE, mass, height, or local gravity — enter any three to find the fourth. Includes preset gravities for Earth, Moon, Mars, Venus, Mercury, Jupiter, Saturn, Uranus, Neptune, and Pluto.",
  },
};

export default meta;
